import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, ButtonIcon } from 'rmwc/Button';
import { Link } from 'react-router-dom'
import { Typography } from 'rmwc/Typography';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { ListDivider } from 'rmwc/List';
import * as api from '../../api/api'
import * as actions from '../../actions'

class MyNotesTab extends Component {
	constructor(props) {
    	super(props)
    	this.state = {
    		data:{
    			resourceData: []
	    	}
		};
	}

	componentDidMount() {
		
	}

	render() {
	    return(
	    	<div>
	    		<Typography use="subtitle2">
                    *This place holds some introduction about the page this page.* Please click on the help button
                    on the top of the page for further assistance regarding hte page.
                </Typography>
                <Grid>
                	<GridCell span = "3">
                		<Button raised style={{width: '100%'}} >Add a Note</Button>
                	</GridCell>
                    <GridCell span = "12">
                        <textarea className = "notepad-component">
                            Textarea with style example
                        </textarea>
                    </GridCell>
                </Grid>
	    	</div>
	    )
	}
}
function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(MyNotesTab);


// WEBPACK FOOTER //
// ./src/views/roadmap/MyNotesTab.jsx